import StencilHTMLElement from "./stencil-element";

class CartDrawer extends StencilHTMLElement {
  lineItems;

  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.lineItems = this.querySelectorAll('card-line-item');
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
  }

}

export default CartDrawer;